"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const page_section_1 = __importDefault(require("~components/page-section"));
const carousel_1 = __importDefault(require("./carousel"));
const SocialProof = ({ title, intro, items }) => ((0, jsx_runtime_1.jsx)(page_section_1.default, { id: "social-proof", headerSpacer: ['x3', null, 'x9'], title: title, intro: intro, children: (0, jsx_runtime_1.jsx)(carousel_1.default, { title: title, items: items }) }));
exports.default = SocialProof;
